module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "logo flex"
  }, [_c('div', {
    staticClass: "logo-image"
  }, [_c('img', {
    attrs: {
      "src": require('../../assets/images/new_logo.png')
    }
  })]), _vm._v(" "), _c('div', [_vm._v("企业注册")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chose-tabs flex flex-center"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chose-item flex flex-center",
      class: {
        active: item.path.includes(_vm.routePath)
      }
    }, [_c('div', {
      staticClass: "index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "main-cont"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04ac55cb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/layout.vue
// module id = 853
// module chunks = 1